<template>
  <div>
    <callout class-panel="bg-transparent" :has-border="false">
      <div class="row">
        <div class="col-sm">
          <div class="d-flex align-items-center">
            <icon i="fas fa-address-book font-14 mr-2" />
            <span>Solicitud de Dispensa</span>
          </div>
        </div>
        <div class="col-sm-6" />
        <div class="col-sm d-flex mr-2">
          <p class="mr-5 font-15 font-weight-normal top-1">
            Total Matrícula Activa:
            <span class="font-weight-bold">{{ serviceTotal }}</span>
          </p>
        </div>
      </div>
      <template #edition>
        <callout
          v-for="(item, index) in dispenseRequestList"
          :key="`dispenseRequestList_${index}`"
          class-main="my-1"
          :has-toggle="false"
        >
          <div class="row">
            <div class="col-md-3">
              <span class="data-name">Número Seguro Social:</span>
              <p class="data">{{ item.specialistSsn }}</p>
            </div>
            <div class="col-md-6">
              <span class="data-name">Nombre:</span>
              <p class="data">{{ item.specialistFullName }}</p>
            </div>
            <div class="col-md-3">
              <span class="data-name">Matrícula Activa:</span>
              <p class="data">{{ item.corpServiceTotal }}</p>
            </div>
          </div>
        </callout>

        <callout
          v-if="dispenseRequestList.length === 0"
          class-main="mt-1"
          :has-toggle="false"
        >
          <div class="left-border-none" />
          <div class="row ">
            <div class="col-sm d-flex justify-content-center text-gray pt-3">
              <p>
                No cuenta con Solicitud de Dispensa
              </p>
            </div>
          </div>
        </callout>
      </template>
    </callout>

    <callout class-main="mt-2" class-panel="bg-transparent" :has-border="false">
      <div class="row">
        <div class="col-sm">
          <div class="d-flex align-items-center">
            <icon i="fas fa-address-book font-14 mr-2" />
            <span>Supervisados en Otra Corporación</span>
          </div>
        </div>
        <div class="col-sm-6" />
        <div class="col-sm d-flex mr-2">
          <p class="mr-5 font-weight-normal font-15 top-1">
            Total Matrícula Activa:
            <span class="font-weight-bold">{{ otherCorporationTotal }}</span>
          </p>
        </div>
      </div>
      <template #edition>
        <callout
          v-for="(item, index) in supervisedOtherCorporationList"
          :key="`supervisedOtherCorporationList_${index}`"
          class-main="mt-1"
          :has-toggle="false"
        >
          <div class="row">
            <div class="col-md-3">
              <span class="data-name">Número Seguro Social:</span>
              <p class="data">{{ item.specialistSsn }}</p>
            </div>
            <div class="col-md-3">
              <span class="data-name">Nombre:</span>
              <p class="data">{{ item.specialistFullName }}</p>
            </div>
            <div class="col-md-3">
              <span class="data-name">Corporación:</span>
              <p class="data">
                {{ item.companyName }}
              </p>
            </div>
            <div class="col-md-3">
              <span class="data-name">Total Matrícula Activa:</span>
              <p class="data">{{ item.serviceTotal }}</p>
            </div>
          </div>
        </callout>

        <callout
          v-if="supervisedOtherCorporationList.length === 0"
          class-main="mt-1"
          :has-toggle="false"
        >
          <div class="left-border-none" />
          <div class="row ">
            <div class="col-sm d-flex justify-content-center text-gray pt-3">
              <p>
                No cuenta con Supervisados en Otra Corporación
              </p>
            </div>
          </div>
        </callout>
      </template>
    </callout>
  </div>
</template>

<style scoped>
.text-gray {
  color: #909090;
  font-weight: 100;
}

.left-border-none {
  border-left: 4px solid #f7f7f7;
  border-radius: 6px;
  height: 100%;
  width: 100px;
  position: absolute;
  top: 0;
  left: -20px;
}

.top-1 {
  position: absolute;
  top: 10px;
}
</style>
<script>
import Icon from '@/views/provider/serviceLocation/components/Icon';

export default {
  name: '',
  components: {
    Icon,
  },
  props: {
    dispenseRequestList: {
      type: Array,
      default: () => [],
    },
    supervisedOtherCorporationList: {
      type: Array,
      default: () => [],
    },
    supervisorInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    serviceTotal() {
      let result = 0;
      this.dispenseRequestList.forEach((x) => (result += x.corpServiceTotal));

      return result;
    },
    otherCorporationTotal() {
      let result = 0;
      this.supervisedOtherCorporationList.forEach(
        (x) => (result += x.serviceTotal)
      );

      return result;
    },
  },
};
</script>
